var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44352 3.77353C3.98396 3.50412 3.40462 3.83434 3.40462 4.36569V13.3012C3.40462 13.8326 3.98396 14.1628 4.44352 13.8934L12.0648 9.42562C12.5179 9.15999 12.5179 8.50694 12.0648 8.2413L4.44352 3.77353ZM2.02588 4.36569C2.02588 2.77164 3.7639 1.78099 5.14257 2.5892L12.7638 7.05698C14.1232 7.85388 14.1232 9.81304 12.7638 10.6099L5.14257 15.0777C3.7639 15.8859 2.02588 14.8953 2.02588 13.3012V4.36569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySupply);
export default __webpack_public_path__ + "static/media/play_supply.5bc35e41d1c504f18e1af2c9a9dc38dd.svg";
export { ForwardRef as ReactComponent };